import { motion } from 'framer-motion';

const STEPS = [
  {
    id: 'stripe',
    title: 'AI companies buy inference',
    body: 'Teams pay for Resonatia API keys or hosting — cheaper distributed / edge models.',
  },
  {
    id: 'treasury',
    title: 'Spend → USDC treasury',
    body: 'That revenue is reserved / swept to USDC on Base to back Essence.',
  },
  {
    id: 'work',
    title: 'Verified work',
    body: 'Self OS nodes + agents settle against the same funded pool.',
  },
  {
    id: 'redeem',
    title: 'Human paths',
    body: 'Convert → Talk credits now; withdraw / redeem when funded.',
  },
];

export function EconomicLoopDiagram() {
  return (
    <div className="relative">
      <p className="mb-8 font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-gold">
        Economic loop
      </p>

      <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-4 md:gap-6">
        {STEPS.map((step, i) => (
          <motion.div
            key={step.id}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.45, delay: i * 0.1 }}
            className="relative border-t border-essence-teal/40 pt-5"
          >
            <span className="font-display text-2xl font-bold text-essence-teal/70">
              {String(i + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-3 font-display text-lg font-semibold text-essence-ink">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-essence-mute">{step.body}</p>
          </motion.div>
        ))}
      </div>

      <svg
        className="mx-auto mt-12 hidden w-full max-w-3xl text-essence-teal/35 md:block"
        viewBox="0 0 720 48"
        fill="none"
        aria-hidden
      >
        <motion.path
          d="M20 24 H700"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeDasharray="6 8"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
        />
        <motion.circle
          cx="20"
          cy="24"
          r="5"
          fill="#2f7a6e"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        />
        <motion.circle
          cx="700"
          cy="24"
          r="5"
          fill="#8f6f2e"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 1 }}
        />
      </svg>

      <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-essence-mute md:text-center">
        Peg is notional (≈ $1). EssenceTreasury is an ops-funded vault for redeemability toward USDC — not a
        regulated stablecoin, not FDIC-insured, and not guaranteed fully funded today.
      </p>
    </div>
  );
}
